/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_Model_Speech_To_TextInputs */



/**
* | output |
* | --- |
* | "Speech to text (Whisper)" |
*
* @param {Usage_Model_Speech_To_TextInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const usage_model_speech_to_text = /** @type {((inputs?: Usage_Model_Speech_To_TextInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Model_Speech_To_TextInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Sprache zu Text (Whisper)")
	return /** @type {LocalizedString} */ ("Speech to text (Whisper)")
});